/* Escalera de cantidad.
   Su único trabajo es escribir la cantidad elegida en el input name="quantity"
   del formulario nativo de Shopify, que es de donde Releasit lee los datos del
   producto. Sin ese input, el formulario abre siempre en 1 aunque el cliente
   haya elegido 3 en la página.
   No toca el precio principal a propósito: cada escalón muestra su propio total. */
(function () {
  'use strict';

  function avisar(input) {
    ['input', 'change'].forEach(function (nombre) {
      var e;
      try {
        e = new Event(nombre, { bubbles: true });
      } catch (err) {
        e = document.createEvent('Event');
        e.initEvent(nombre, true, true);
      }
      input.dispatchEvent(e);
    });
  }

  function aplicar(n) {
    if (!n || n < 1) n = 1;
    var campos = document.querySelectorAll('[data-lp-qty]');
    for (var i = 0; i < campos.length; i++) {
      if (campos[i].value !== String(n)) {
        campos[i].value = n;
        avisar(campos[i]);
      }
    }
  }

  function leer(el) {
    return parseInt(el.getAttribute('data-cant'), 10) || 1;
  }

  function iniciar() {
    var escaleras = document.querySelectorAll('[data-lp-esc]');
    if (!escaleras.length) return;

    for (var i = 0; i < escaleras.length; i++) {
      (function (caja) {
        if (caja.getAttribute('data-listo') === '1') return;
        caja.setAttribute('data-listo', '1');

        caja.addEventListener('change', function (ev) {
          var t = ev.target;
          if (t && t.hasAttribute && t.hasAttribute('data-cant')) aplicar(leer(t));
        });

        var marcado = caja.querySelector('[data-cant]:checked');
        if (marcado) aplicar(leer(marcado));
      })(escaleras[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
